import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceForm from '../../../components/forms/InvoiceForm';
import { useInvoiceApi } from '../../../hooks/useInvoiceApi';
import { useNavigate, useParams } from 'react-router-dom';
import { InvoiceDTO } from '../../../services/apiClient';

const InvoiceEdit: React.FC = () => {
  const { getById, edit } = useInvoiceApi();
  const [entityData, setEntityData] = useState<InvoiceDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoices', href: '/admin/invoices' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Invoice data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/invoices');
    } catch (error) {
      console.error('Error updating Invoice:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoices"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.Invoice.Edit'
    >
        {entityData ? (
          <InvoiceForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/invoices')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default InvoiceEdit;